import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAuthContext } from 'crm-cards-sdk/internal/AuthContext';
import { useCardLocationContext } from 'crm-cards-sdk/internal/CardLocationContext';
import HubSpotAppLink from 'crm-links/common/components/HubSpotAppLink';
import { HUBSPOT_APP_LINK_TYPES } from 'crm-links/common/context/HubSpotAppLinkHandlerContext';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Button } from 'foundations-components/transitional/components/Button';
import { useIsLocationEnabledForObjectType } from 'location-customization-utils-lib/hooks/useIsLocationEnabledForObjectType';
import { useMemo } from 'react';
import { SettingsIcon } from 'foundations-assets/icons/components/SettingsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LOCATION_TO_PAGE_EDITOR_LOCATION_MAP = {
  CRM_RECORD_MIDDLE: 'CRM_RECORD_PAGE'
};
const SettingsButtonComponent = props => {
  return /*#__PURE__*/_jsx(Button, Object.assign({}, props, {
    use: "transparent",
    paddingInlineEnd: "0"
  }));
};
const TabsWithSettingsButton = ({
  children
}) => {
  const {
    scopes,
    gates
  } = useAuthContext();
  const {
    location,
    additionalLocationData: {
      objectTypeId = ''
    }
  } = useCardLocationContext();
  const settingsLocation = LOCATION_TO_PAGE_EDITOR_LOCATION_MAP[location] || location;
  const {
    isLocationEnabledForObjectType
  } = useIsLocationEnabledForObjectType({
    objectTypeId,
    location: settingsLocation,
    scopes: Array.from(scopes),
    gates: Array.from(gates)
  });
  const linkTypeProps = useMemo(() => {
    return {
      objectTypeId,
      location: settingsLocation
    };
  }, [objectTypeId, settingsLocation]);
  const LinkComponentProps = useMemo(() => {
    return {
      'data-test-id': `location-settings-button_${location}`
    };
  }, [location]);
  if (!isLocationEnabledForObjectType) {
    return children;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(Box, {
      grow: 1,
      minInlineSize: "0",
      children: children
    }), /*#__PURE__*/_jsxs(HubSpotAppLink, {
      linkType: HUBSPOT_APP_LINK_TYPES.LOCATION_SETTINGS,
      linkTypeProps: linkTypeProps,
      LinkComponent: SettingsButtonComponent,
      LinkComponentProps: LinkComponentProps,
      children: [/*#__PURE__*/_jsx(SettingsIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "crmCards.locationSettingsButton"
      })]
    })]
  });
};
export default TabsWithSettingsButton;